import React from 'react';
import { FormattedMessage, injectIntl } from '../../util/reactIntl';
import classNames from 'classnames';
import {
  LINE_ITEM_CUSTOMER_COMMISSION,
  LINE_ITEM_PROVIDER_COMMISSION,
} from '../../util/types';
import LineItemBasePriceMaybe from './LineItemBasePriceMaybe';
import LineItemUnitsMaybe from './LineItemUnitsMaybe';
import LineItemSubTotalMaybe from './LineItemSubTotalMaybe';
import LineItemLongTermDiscountMaybe from './LineItemLongTermDiscountMaybe';
import LineItemEveningDiscountMaybe from './LineItemEveningDiscountMaybe';
import LineItemPartnershipDiscountMaybe from './LineItemPartnershipDiscountMaybe';
import LineItemPromoDiscountMaybe from './LineItemPromoDiscountMaybe';
import LineItemCustomerCommissionMaybe from './LineItemCustomerCommissionMaybe';
import LineItemCustomerCommissionRefundMaybe from './LineItemCustomerCommissionRefundMaybe';
import LineItemProviderCommissionMaybe from './LineItemProviderCommissionMaybe';
import LineItemProviderCommissionRefundMaybe from './LineItemProviderCommissionRefundMaybe';
import LineItemRefundMaybe from './LineItemRefundMaybe';
import LineItemTotalPrice from './LineItemTotalPrice';
import CustomerDetails from './CustomerDetails';

import css from './BookingBreakdown.css';

export const BookingBreakdownComponent = props => {
  const {
    rootClassName,
    className,
    userRole,
    unitType,
    transaction,
    intl,
    displayPromoLineItem = true,
    displayCustomerDetails,
    promoCodeComponent: Component,
  } = props;

  const isCustomer = userRole === 'customer';
  const isProvider = userRole === 'provider';

  const hasCommissionLineItem = transaction.attributes.lineItems.find(item => {
    if (!item) return;

    const { code, reversal } = item;
    const hasCustomerCommission = isCustomer && code === LINE_ITEM_CUSTOMER_COMMISSION;
    const hasProviderCommission = isProvider && code === LINE_ITEM_PROVIDER_COMMISSION;
    return (hasCustomerCommission || hasProviderCommission) && !reversal;
  });

  const classes = classNames(rootClassName || css.root, className);

  return (
    <div className={classes}>
      <hr className={css.totalDivider} />
      {displayCustomerDetails && <CustomerDetails transaction={transaction} isProvider={isProvider} />}

      <LineItemUnitsMaybe transaction={transaction} unitType={unitType} />

      <LineItemBasePriceMaybe transaction={transaction} unitType={unitType} intl={intl} />

      <LineItemLongTermDiscountMaybe
        transaction={transaction}
        unitType={unitType}
        intl={intl}
      />
      <LineItemEveningDiscountMaybe
        transaction={transaction}
        unitType={unitType}
        intl={intl}
      />
      <LineItemPartnershipDiscountMaybe
        transaction={transaction}
        unitType={unitType}
        intl={intl}
      />

      {
        displayPromoLineItem &&
        <LineItemPromoDiscountMaybe
          transaction={transaction}
          unitType={unitType}
          intl={intl}
        />
      }

      <LineItemSubTotalMaybe
        transaction={transaction}
        unitType={unitType}
        userRole={userRole}
        intl={intl}
      />

      <LineItemRefundMaybe transaction={transaction} intl={intl} />

      <LineItemCustomerCommissionMaybe
        transaction={transaction}
        isCustomer={isCustomer}
        intl={intl}
      />
      <LineItemCustomerCommissionRefundMaybe
        transaction={transaction}
        isCustomer={isCustomer}
        intl={intl}
      />
      {
        transaction?.attributes?.phone !== 'emulated' &&
        <LineItemProviderCommissionMaybe
          transaction={transaction}
          isProvider={isProvider}
          intl={intl}
        />
      }
      <LineItemProviderCommissionRefundMaybe
        transaction={transaction}
        isProvider={isProvider}
        intl={intl}
      />
      {Component}
      <LineItemTotalPrice transaction={transaction} isProvider={isProvider} intl={intl} />

      {hasCommissionLineItem ? (
        <span className={css.feeInfo}>
          <FormattedMessage id="BookingBreakdown.commissionFeeNote" />
        </span>
      ) : null}
    </div>
  );
};

const BookingBreakdown = injectIntl(BookingBreakdownComponent);

BookingBreakdown.displayName = 'BookingBreakdown';

export default BookingBreakdown;
